import React from 'react'

const SvgPhone = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <path d="M26.111 24.111c-1.111 0-2.178-.178-3.173-.507a.991.991 0 00-.276-.044c-.23 0-.453.107-.63.258l-1.956 1.955a13.4 13.4 0 01-5.858-5.849l1.955-1.964a.873.873 0 00.223-.898 10.098 10.098 0 01-.507-3.173c0-.489-.4-.889-.889-.889h-3.111c-.489 0-.889.4-.889.889C11 22.236 17.764 29 26.111 29c.489 0 .889-.4.889-.889V25c0-.489-.4-.889-.889-.889zm-13.307-9.333h1.334c.062.782.195 1.555.418 2.302l-1.076 1.076a13.323 13.323 0 01-.676-3.378zm12.418 12.418a13.246 13.246 0 01-3.378-.676l1.067-1.076c.756.223 1.529.356 2.311.41v1.342zM19 13v8.889l2.667-2.667H27V13h-8zm6.222 4.444h-4.444v-2.666h4.444v2.666z" />
  </svg>
)

export default SvgPhone
